import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper/bundle"

// Import CSS swiper jika menggunakan build tools (esbuild/webpacker).
// Jika menggunakan importmaps, pastikan link CSS CDN di head layout tetap ada
// atau import CSS-nya di application.css.

export default class extends Controller {
  static targets = ["swiperContainer", "modal"]
  static values = {
    initialIndex: { type: Number, default: 0 }
  }

  connect() {
    // 1. Inisialisasi Swiper saat controller terhubung
    this.initSwiper()
  }

  disconnect() {
    // Bersihkan instance swiper jika pindah halaman (turbolinks/turbo)
    if (this.swiper) {
      this.swiper.destroy()
    }
  }

  // --- SWIPER LOGIC ---

  initSwiper() {
    // this.swiperContainerTarget mengacu pada elemen dengan data-service-item-target="swiperContainer"
    this.swiper = new Swiper(this.swiperContainerTarget, {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    })
  }

  // Action untuk thumbnail click
  slideTo(event) {
    // Ambil index dari params (data-service-item-index-param="0")
    const index = event.params.index
    
    // Gunakan slideToLoop agar kompatibel dengan mode loop: true
    this.swiper.slideToLoop(index)
  }

  // --- MODAL RAB LOGIC ---

  openModal(event) {
    event.preventDefault()
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden" // Lock scroll body
  }

  closeModal(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = "auto" // Unlock scroll body
  }

  // Menutup modal jika user menekan tombol ESC (via Action window)
  handleKeydown(event) {
    if (event.key === "Escape") {
      this.closeModal()
    }
  }
}